import { useEffect, useRef, useState } from "react";
import { Globe, Phone, TrendingUp, Mail, BarChart3, Users } from "lucide-react";
import TrustLogos from "./TrustLogos";

const stats = [
  { icon: Globe, value: "650", label: "Websites Launched" },
  { icon: Phone, value: "60.6K", label: "Phone Calls Generated" },
  { icon: BarChart3, value: "$2.53M", label: "Ad Spend Managed" },
  { icon: TrendingUp, value: "6,530", label: "SEO Pages Optimized" },
  { icon: Mail, value: "26.2M", label: "Mailers Sent" },
  { icon: Users, value: "95%", label: "Client Retention" },
];

const StatsRibbon = () => {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.2 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="bg-hero-bg border-b border-hero-foreground/10" ref={ref}>
      {/* Compact stats strip */}
      <div className="py-6 md:py-8 border-b border-hero-foreground/10">
        <div className="max-w-7xl mx-auto section-padding">
          <div className={`grid grid-cols-3 md:grid-cols-6 gap-6 md:gap-4 ${visible ? "reveal-up" : "opacity-0"}`}>
            {stats.map((stat) => (
              <div key={stat.label} className="text-center">
                <stat.icon className="w-4 h-4 text-accent/80 mx-auto mb-1.5" />
                <p className="text-xl md:text-2xl font-bold text-hero-foreground tracking-tight">
                  {stat.value}
                </p>
                <p className="text-[10px] md:text-xs text-hero-foreground/50 mt-0.5 font-medium leading-tight">
                  {stat.label}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Trust logos */}
      <div className="py-6 md:py-8">
        <div className="max-w-5xl mx-auto section-padding">
          <p className="text-center text-[10px] font-semibold uppercase tracking-widest text-hero-foreground/30 mb-5">
            Trusted Partnerships
          </p>
          <TrustLogos />
        </div>
      </div>
    </section>
  );
};

export default StatsRibbon;
